/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Brian Bal
 */

import { getProperty } from "trux"
import { getAllSpotlights } from "trux/dist/organisms/VideoPlayer"
import { videoPlayerBasePath } from "../../util/apiFolder"

export const eventsToMoments = (events, game, playlist) => {
    let moments = []
    let focusPlayer = getProperty("scope.player.trace_number", playlist, "")

    let players = {}
    for (let p of getProperty("home_team.players", game, [])) {
        players[p.trace_number] = {
            id: getProperty("trace_number", p, ""),
            user_id: getProperty("user.user_id", p, ""),
            first_name: getProperty("user.first_name", p, ""),
            last_name: getProperty("user.last_name", p, ""),
            abr: getProperty("user.abbr", p, ""),
            jersey_number: getProperty("jersey", p, ""),
            pos: "",
            team: getProperty("home_team.name", game, ""),
            name: getProperty("user.abbr", p, ""),
        }
    }

    let timeline = getProperty("timeline", game, { spotlight: [] })
    for (let event of events) {
        let m = eventToMoment(event, game, focusPlayer, players)
        let spots = getAllSpotlights(event, playlist, timeline)
        if (spots) {
            m.spotlights = spots
        }
        moments.push(m)
    }

    return moments
}

export const eventToMoment = (event, game, focusPlayer, players) => {
    let eventSources = getProperty("sources", event, [])
    let sources = []
    for (let es of eventSources) {
        sources.push(eventToMoment(es, game, focusPlayer, players))
    }

    let radar = {
        focus_players: getProperty("meta.all_trace_numbers", event, []),
        focus_player: focusPlayer,
        players: {},
    }
    for (let p of game.home_team.players) {
        radar.players[p.trace_number] = {
            id: getProperty("trace_number", p, ""),
            user_id: getProperty("user.user_id", p, ""),
            first_name: getProperty("user.first_name", p, ""),
            last_name: getProperty("user.last_name", p, ""),
            abr: getProperty("user.abbr", p, ""),
            jersey_number: getProperty("jersey", p, ""),
            pos: "",
            team: getProperty("home_team.name", game, ""),
            name: getProperty("user.abbr", p, ""),
        }
    }

    let meta = { ...event.meta }
    if (!meta.camera) {
        meta.camera = {
            category: "camera",
            name: "tracecam",
            title: "TraceCam",
            type: "Trace",
        }
    }

    return {
        event_number: getProperty("event_number", event, 1),
        full_game_time: getProperty("full_game_time", event, 0),
        game_clip_id: getProperty("game_clip_id", event, 0),
        game_id: getProperty("game_id", event, 0),
        team_id: getProperty("team_id", event, 0),
        start_time: getProperty("utc_time", event, 0),
        base_path: videoPlayerBasePath(game),
        duration: getProperty("duration", event, 30),
        half: getProperty("half", event, 1),
        time: getProperty("time", event, 0),
        title: getProperty("title", event, "--"),
        type: getProperty("meta.type", event, "touch"),
        start_third: getProperty("meta.thirds.0", event, "defensive"),
        end_third: getProperty("meta.thirds.1", event, "defensive"),
        dynamic_audio: getProperty("dynamic.audio", event, ""),
        dynamic_duration: getProperty("dynamic.duration", event, 30),
        dynamic_hls: getProperty("dynamic.hls", event, ""),
        dynamic_jfile: getProperty("dynamic.jfile", event, ""),
        dynamic_offset: getProperty("dynamic.offset", event, 0),
        dynamic_start: getProperty("dynamic.start", event, 0),
        keywords: getProperty("meta.keywords", event, []),
        thirds: getProperty("meta.thirds", event, []),
        trace_numbers: getProperty("meta.trace_numbers", event, []),
        home_team: getProperty("meta.home_team", event, null),
        away_team: getProperty("meta.away_team", event, null),
        spotlights: getProperty("meta.spotlights", event, null),
        tags: getProperty("tags", event, null),
        sport_type: getProperty("sport_type", event, "soccer"),
        parent_ref_id: null,
        touch_times: getProperty("meta.touch_times", event, []),
        players: getProperty("players", event, []),
        sources,
        radar,
        meta,
    }
}
